import { THRESHOLD_COLORS_CODES } from 'utils/ColorUtil'
import { blackColor, brightOrange, IAEAU_SCALE_COLORS } from 'utils/constants/ColorTheme'
import fillMap from './MapStylesUtils'

export default {
    FILL_RED: fillMap('rgba(255,255,255,0.5)', THRESHOLD_COLORS_CODES.RED),
    FILL_BLACK: fillMap('rgba(255,255,255,0.5)', blackColor),
    FILL_BLUE_GREEN: fillMap('rgba(255,255,255,0.3)', IAEAU_SCALE_COLORS.EXCELLENT),
    FILL_BLUE: fillMap('rgba(255,255,255,0.3)', THRESHOLD_COLORS_CODES.BLUE),
    FILL_YELLOW: fillMap('rgba(255,255,255,0.5)', THRESHOLD_COLORS_CODES.YELLOW),
    FILL_ORANGE: fillMap('rgba(255,255,255,0.5)', brightOrange),
}
